(function () {
  const ROOT = document.documentElement;
  const PRESS_HASH = '#press';
  const EXIT_DURATION = 180;

  let isTransitioning = false;

  function getView() {
    return window.location.hash.toLowerCase() === PRESS_HASH
      ? 'press'
      : 'lead';
  }

  function prefersReducedMotion() {
    return window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
  }

  function renderView(options = {}) {
    const view = getView();

    ROOT.setAttribute(
      'data-password-view',
      view
    );

    if (document.body) {
      document.body.setAttribute(
        'data-password-view',
        view
      );
    }

    if (options.resetScroll) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      });
    }
  }

  function updateUrl(view) {
    const baseUrl =
      window.location.pathname +
      window.location.search;

    if (view === 'press') {
      window.history.pushState(
        {
          wamboltPasswordView: 'press'
        },
        '',
        `${baseUrl}${PRESS_HASH}`
      );
    } else {
      window.history.pushState(
        {
          wamboltPasswordView: 'lead'
        },
        '',
        baseUrl
      );
    }
  }

  function transitionToView(view) {
    if (isTransitioning) return;

    const currentView = getView();

    if (currentView === view) return;

    if (prefersReducedMotion()) {
      updateUrl(view);

      renderView({
        resetScroll: true
      });

      return;
    }

    isTransitioning = true;

    ROOT.classList.add(
      'is-password-transitioning'
    );

    window.setTimeout(() => {
      updateUrl(view);

      renderView({
        resetScroll: true
      });

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          ROOT.classList.remove(
            'is-password-transitioning'
          );

          ROOT.classList.add(
            'is-password-entering'
          );

          window.setTimeout(() => {
            ROOT.classList.remove(
              'is-password-entering'
            );

            isTransitioning = false;
          }, 320);
        });
      });
    }, EXIT_DURATION);
  }

  function handleClick(event) {
    const pressLink = event.target.closest(
      '[data-password-go-press]'
    );

    if (pressLink) {
      event.preventDefault();
      transitionToView('press');
      return;
    }

    const leadLink = event.target.closest(
      '[data-password-go-lead]'
    );

    if (leadLink) {
      event.preventDefault();
      transitionToView('lead');
    }
  }

  function handleLocationChange() {
    renderView({
      resetScroll: true
    });
  }

  function init() {
    renderView();

    if (window.__wamboltPasswordRouterBound) {
      return;
    }

    window.__wamboltPasswordRouterBound = true;

    document.addEventListener(
      'click',
      handleClick
    );

    window.addEventListener(
      'hashchange',
      handleLocationChange
    );

    window.addEventListener(
      'popstate',
      handleLocationChange
    );

    document.addEventListener(
      'shopify:section:load',
      renderView
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();